<template>
  <!--用户管理 -->
  <div>
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>用户账号：</div>
          <el-input placeholder="请输入搜索内容..." size="small" style="width: 160px;margin-right: 10px"
                    v-model="parameterMap.username"
                    clearable></el-input>
          <div>用户昵称：</div>
          <el-input placeholder="请输入搜索内容..." size="small" style="width: 160px;margin-right: 10px"
                    v-model="parameterMap.nickname"
                    clearable></el-input>
          <div>用户类型：</div>
          <el-select v-model="parameterMap.user_type" clearable placeholder="请选择用户类型" size="small" style="width: 160px"
                     @clear="getUserList">
            <el-option
                v-for="item in userTypeData"
                :key="item.enumeration"
                :label="item.name"
                :value="item.enumeration">
            </el-option>
          </el-select>
          <div style="margin-left: 10px">所属城市：</div>
          <el-select v-model="parameterMap.area_code" clearable filterable placeholder="请选择所属城市"
                     size="small" style="width: 160px;margin: 0 10px"
                     @clear="getUserList">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="btnList.includes('user_add')" size="small" type="success" @click="addBtn">新增</el-button>
        </div>
        <el-table
            :data="tableData"
            border
            size="small"
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column header-align="center" label="用户头像">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-avatar :size="32" :src="scope.row.head_img_url"></el-avatar>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="用户账号" prop="username"></el-table-column>
          <el-table-column align="center" label="用户昵称" prop="nickname"></el-table-column>
          <el-table-column align="center" label="用户类型" prop="user_type_name"></el-table-column>
          <el-table-column align="center" label="所属城市" prop="city_name"></el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="440"
          >
            <template slot-scope="scope">
              <el-button v-if="btnList.includes('user_edit')" size="mini" type="success" @click="editBtn(scope.row)">
                修改
              </el-button>
              <el-button v-if="btnList.includes('user_freeze')"
                         :type="scope.row.delete_status === '1'?'danger':'warning'" size="mini"
                         @click="freezeBtn(scope.row)">{{ scope.row.delete_status === '1' ? '冻结' : '解冻' }}
              </el-button>
              <el-button v-if="btnList.includes('user_pwd')" size="mini" type="primary"
                         @click="changePwdBtn(scope.row)">重置密码
              </el-button>
              <el-button v-if="btnList.includes('user_add_role')" size="mini" type="primary"
                         @click="addRoleBtn(scope.row)">添加角色
              </el-button>
              <el-button v-if="btnList.includes('user_view_role')" size="mini" type="primary"
                         @click="viewRoleBtn(scope.row)">查看角色
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[20, 30, 40, 50]"
            :total="totalElements"
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="display: flex;justify-content: center;margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>

      </el-card>
    </div>
    <!-- 新增用户的弹窗 -->
    <a-modal
        :title="addDialogTitle"
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="500px"
        @cancel="userAddCancel"
        @ok="userAddSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="150px"
      >
        <el-form-item label="用户头像" prop="headImgUrl">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.headImgUrl" :src="ruleForm.headImgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="ruleForm.userName" :disabled="addDialogTitle === '编辑用户'?true:false" clearable
                    placeholder="请输入用户账号" size="small" style="width: 200px" type="text"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickName">
          <el-input v-model="ruleForm.nickName" maxlength="30" clearable placeholder="请输入用户昵称" size="small"
                    style="width: 200px"
                    type="text"></el-input>
        </el-form-item>
        <el-form-item v-if="addDialogTitle === '新增用户'" label="用户密码" prop="passWord">
          <el-input v-model="ruleForm.passWord" clearable placeholder="请输入用户密码" show-password size="small"
                    style="width: 200px"
                    type="text"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="ruleForm.phone" maxlength="11" clearable placeholder="请输入手机号码" size="small" style="width: 200px"
                    type="text"></el-input>
        </el-form-item>
        <el-form-item label="用户邮箱" prop="email">
          <el-input v-model="ruleForm.email" clearable placeholder="请输入用户邮箱" size="small" style="width: 200px"
                    type="text"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType">
          <el-select v-model="ruleForm.userType" clearable placeholder="请选择用户类型" size="small" style="width: 200px">
            <el-option
                v-for="item in userTypeData"
                :key="item.enumeration"
                :label="item.name"
                :value="item.enumeration">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属城市" prop="areaCode">
          <el-select v-model="ruleForm.areaCode" clearable filterable placeholder="请选择所属城市" size="small"
                     style="width: 200px">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    重置密码的弹窗-->
    <a-modal
        :visible="pwdDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="重置密码"
        width="400px"
        @cancel="pwdCancel"
        @ok="pwdSubmit('pwdRuleForm')"
    >
      <el-form
          ref="pwdRuleForm"
          :model="pwdRuleForm"
          :rules="pwdRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="新密码" prop="passWord">
          <el-input v-model="pwdRuleForm.passWord" clearable placeholder="请输入新密码" show-password size="small"
                    style="width: 200px" type="text"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    添加角色的弹窗-->
    <a-modal
        :title="addRoleTitle"
        :visible="addRoleDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="addRoleCancel"
        @ok="addRoleSubmit"
    >
      <el-tree
          ref="tree"
          :data="addRoleTitle==='添加角色'?roleData:viewRoleData"
          :props="defaultProps"
          :show-checkbox="addRoleTitle==='添加角色'"
          default-expand-all
          highlight-current
          node-key="id"
          @check-change="checkChange">
      </el-tree>
    </a-modal>

    <!--    冻结用户弹窗-->
    <a-modal
        title="提示"
        :visible="freezeDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="freezeCancel"
        @ok="freezeSubmit"
    >
      <div>是否冻结该用户？</div>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "@/api/config";

export default {
  data() {
    // 自定义验证邮箱
    let checkEmail = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        console.log(regEmail.test(value));
        return callback();
      } else {
        callback(new Error("请输入合法邮箱"));
      }
    };
    // 自定义验证手机号
    let checkPhone = (rule, value, callback) => {
      console.log(typeof value, "\\\\/");
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("手机号格式不正确"));
        }
      }
    };
    return {
      pageNum: 1,//当前页码
      pageSize: 20,//每个页面展示多少条
      parameterMap: {
        username: "",
        nickname: "",
        user_type: "",
        area_code: ""
      },
      totalElements: 0,//数据总数
      addDialogState: false,//新增弹窗开启关闭
      addDialogTitle: '',
      uploadApiUrl:'',
      ruleForm: {
        id: "",
        userName: "",
        passWord: "",
        nickName: "",
        headImgUrl: "",
        userType: "",
        areaCode: "",
        phone: "",
        email: ""
      },
      rules: {
        headImgUrl: [{required: true, message: "请上传头像", trigger: "blur"}],
        userName: [{required: true, message: "请输入用户账号", trigger: "blur"}],
        nickName: [{required: true, message: "请输入用户昵称", trigger: "blur"}],
        passWord: [{required: true, message: "请输入用户密码", trigger: "blur"}],
        phone: [{required: true, message: "请输入用户密码", trigger: "blur"}, {validator: checkPhone, trigger: "blur"}],
        email: [{required: true, message: "请输入用户密码", trigger: "blur"}, {validator: checkEmail, trigger: "blur"}],
        userType: [{required: true, message: "请选择用户类型", trigger: "blur"}],
        areaCode: [{required: true, message: "请选择所属地区", trigger: "blur"}],
      },
      userTypeData: [],
      areaData: [],
      tableData: [], //用户列表
      pwdDialogState: false,
      pwdRuleForm: {
        id: "",
        passWord: ""
      },
      pwdRules: {
        passWord: [{required: true, message: "请输入新密码", trigger: "blur"}]
      },
      addRoleDialogState: false,
      addRoleTitle: '',
      roleData: [],
      defaultProps: {
        children: 'children',
        label: 'role_name'
      },
      currentUserId: '',
      viewRoleData: [],
      isFinishLoad: false,


      freezeDialogState: false,
      freezeRow: {},

      btnList: []
    };
  },
  methods: {
    //获取用户分类字典数据
    getUserType() {
      this.getAxios("/dic/list/userType").then(res => {
        if (res.success) {
          this.userTypeData = res.content
        } else {
          this.userTypeData = []
        }
      })
    },
    //获取所有开放城市
    getAllArea() {
      this.getAxios("/area/getAllArea").then(res => {
        if (res.success) {
          this.areaData = res.content
        } else {
          this.areaData = []
        }
      })
    },
    userAddCancel() {
      this.addDialogState = false;
      this.$refs.ruleForm.clearValidate();
    },
    pwdCancel() {
      this.pwdDialogState = false
      this.$refs.pwdRuleForm.clearValidate();
    },
    pwdSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/sysUser/updSysUser", {
            id: this.pwdRuleForm.id,
            updateType: 3,
            passWord: this.pwdRuleForm.passWord
          }).then(res => {
            if (res.success) {
              this.pwdDialogState = false
              this.$message.success('修改成功!')
              this.getUserList();
            }
          })
        }
      });
    },
    addRoleSubmit() {
      this.addRoleDialogState = false
      this.$message.success("保存成功!")
    },
    addRoleCancel() {
      this.addRoleDialogState = false
    },
    freezeSubmit() {
      this.postAxios("/sysUser/updSysUser", {
        id: this.freezeRow.id,
        updateType: 2,
        deleteStatus: this.freezeRow.delete_status === '1' ? '2' : '1'
      }).then(res => {
        if (res.success) {
          this.freezeDialogState = false
          this.$message.success(this.freezeRow.delete_status === '1' ? '冻结成功!' : '解冻成功!')
          this.getUserList()
        }
      })
    },
    freezeCancel() {
      this.freezeDialogState = false
    },
    //添加用户：
    addBtn() {
      this.ruleForm = {
        userName: "",
        passWord: "",
        nickName: "",
        headImgUrl: "",
        userType: "",
        areaCode: "",
        phone: "",
        email: ""
      }
      this.addDialogTitle = '新增用户'
      this.addDialogState = true;
    },
    //编辑用户
    editBtn(row) {
      this.ruleForm.id = row.id
      this.ruleForm.userName = row.username
      this.ruleForm.nickName = row.nickname
      this.ruleForm.headImgUrl = row.head_img_url
      this.ruleForm.userType = row.user_type
      this.ruleForm.areaCode = row.area_code
      this.ruleForm.phone = row.phone
      this.ruleForm.email = row.email
      this.addDialogTitle = '编辑用户'
      this.addDialogState = true
    },
    //冻结/解冻用户
    freezeBtn(row) {
      if (row.delete_status === '1') {
        this.freezeRow = row
        this.freezeDialogState = true
      } else {
        this.postAxios("/sysUser/updSysUser", {
          id: row.id,
          updateType: 2,
          deleteStatus: row.delete_status === '1' ? '2' : '1'
        }).then(res => {
          if (res.success) {
            this.$message.success(row.delete_status === '1' ? '冻结成功!' : '解冻成功!')
            this.getUserList()
          }
        })
      }
    },
    //重置密码
    changePwdBtn(row) {
      this.pwdRuleForm.id = row.id
      this.pwdRuleForm.passWord = ""
      this.pwdDialogState = true
    },
    //添加角色
    addRoleBtn(row) {
      this.addRoleTitle = '添加角色'
      this.currentUserId = row.id
      //查询该用户拥有的角色，然后复现数据
      this.postAxios("/sysUser/selRoleByUserId", {
        parameterMap: {
          userId: this.currentUserId
        }
      }).then(res => {
        if (res.success) {
          this.isFinishLoad = false
          this.addRoleDialogState = true
          setTimeout(() => {
            if (res.content && res.content.length) {
              let list = []
              res.content.forEach((item) => {
                list.push(item.sys_role_id)
              })
              this.$refs.tree.setCheckedKeys(list);
            } else {
              this.$refs.tree.setCheckedKeys([]);
            }
          }, 100)
          setTimeout(() => {
            this.isFinishLoad = true
          }, 500)
        }
      })
    },
    //查看角色
    viewRoleBtn(row) {
      this.addRoleTitle = '查看角色'
      this.currentUserId = row.id
      this.postAxios("/sysUser/selRoleByUserId", {
        parameterMap: {
          userId: this.currentUserId
        }
      }).then(res => {
        if (res.success) {
          if (res.content && res.content.length) {
            this.viewRoleData = []
            this.roleData.forEach((item) => {
              res.content.forEach((childItem) => {
                if (item.id === childItem.sys_role_id) {
                  this.viewRoleData.push(item)
                }
              })
            })
          } else {
            this.viewRoleData = []
          }
          this.addRoleDialogState = true
        }
      })
    },
    searchBtn() {
      this.getUserList()
    },
    //当前节点变化
    checkChange(row, checkState, state) {
      console.log('点击当前节点', row, checkState, state)
      if (this.isFinishLoad) {
        if (checkState) {
          this.postAxios("/sysUser/addRoleForUser",
              [{userId: this.currentUserId, roleId: row.id}]
          )
        } else {
          this.postAxios("/sysUser/delRoleById",
              {
                parameterMap: {
                  userId: this.currentUserId,
                  roleIdList: [row.id]
                }
              }
          )
        }
      }
    },
    resetBtn() {
      this.parameterMap.area_code = ""
      this.parameterMap.user_type = ""
      this.parameterMap.username = ""
      this.parameterMap.nickname = ""
      this.pageNum = 1
      this.pageSize = 20
      this.getUserList()
    },
    // 确认添加用户：
    userAddSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addDialogTitle === '新增用户') {
            this.postAxios("/sysUser/addSysUser", {
              userName: this.ruleForm.userName,
              passWord: this.ruleForm.passWord,
              nickName: this.ruleForm.nickName,
              headImgUrl: this.ruleForm.headImgUrl,
              userType: this.ruleForm.userType,
              areaCode: this.ruleForm.areaCode,
              phone: this.ruleForm.phone,
              email: this.ruleForm.email
            }).then(res => {
              if (res.success) {
                this.addDialogState = false
                this.$message.success('添加成功!')
                this.getUserList();
              }
            })
          } else {
            this.postAxios("/sysUser/updSysUser", {
              id: this.ruleForm.id,
              updateType: 1,
              nickName: this.ruleForm.nickName,
              headImgUrl: this.ruleForm.headImgUrl,
              userType: this.ruleForm.userType,
              areaCode: this.ruleForm.areaCode,
              phone: this.ruleForm.phone,
              email: this.ruleForm.email
            }).then(res => {
              if (res.success) {
                this.addDialogState = false
                this.$message.success('修改成功!')
                this.getUserList();
              }
            })
          }
        }
      });
    },
    //用户列表
    getUserList() {
      this.postAxios("/sysUser/selSysUser", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: this.parameterMap
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.totalElements = res.totalCount
          console.log(this.totalElements, 'this.totalElements')
        } else {
          this.tableData = []
        }
      });
    },
    //角色列表
    getRoleList() {
      this.postAxios("/sysUser/selSysRole", {
        parameterMap: {}
      }).then(res => {
        if (res.success) {
          this.roleData = []
          this.roleData = res.content;
        } else {
          this.roleData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getUserList()
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.headImgUrl = res.entity;
      }
    },
    beforeAvatarUpload(file) {
      console.log(file, 999)
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadUserHeadImg'
    this.getUserType();//获取用户类型
    this.getAllArea();//获取所有开放城市
    this.getUserList(); //用户的列表
    this.getRoleList();//获取角色的列表
    //获取用户当前页面的按钮权限
    if (this.$store.state.buttonPermission && this.$store.state.buttonPermission.length) {
      this.btnList = []
      this.$store.state.buttonPermission.forEach((item) => {
        if (item.page_code === '/system/user') {
          this.btnList.push(item.action)
        }
      })
    }
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 100px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  display: block;
}
</style>
